import styled from 'styled-components'

import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.g200};
    padding-top: 50px;
    padding-bottom: 50px;

    @media ${(props) => props.theme.query.mobile} {
        padding-left: 20px;
        padding-right: 20px;
    }
`

export const Title = styled.h2`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g500};
    margin-bottom: 40px;
    text-align: center;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL};
    }
`

export const LogosWrapper = styled.div`
    overflow-x: auto;
`

export const GridItem = styled(Grid)`
    text-align: center;
`

export const Link = styled.a`
    display: inline-block;
`
